import styled from "styled-components";

import Banners from "../../../images/programmer_coding.svg";

import {
  borderRadius,
  boxShadowColor,
  lightColor,
  secondaryColor,
} from "../variables.styles";

export const Banner = styled.div`
  background: linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7)),
    url(${Banners});
  object-fit: cover;
  overflow: hidden; // for some reason, this fixes the top bar issue
  color: ${lightColor};
  padding: 7rem 0 0 1rem;
  display: grid;
  grid-template-columns: 1fr minmax(200px, 500px) 3fr;

  .mutted,
  .banner-button,
  .title,
  .info {
    grid-column: 2;
  }
`;

const basicButton = {
  props: `
    background-color: ${secondaryColor};
    border: none;
    border-radius: ${borderRadius};
    padding: 1rem 2rem;
    font-weight: bolder;
    font-size: 1.2em;
    box-shadow: 0 0 3px 2px ${boxShadowColor};
    width: max-content;
    cursor: pointer;
    text-align: center;`,
  hoverEffects: `
    box-shadow: 0 0 5px 5px ${boxShadowColor};`,
};

export const Button = styled.button`
  ${basicButton.props};
  &:hover {
    ${basicButton.hoverEffects}
  }
`;

export const LinkButton = styled.a`
  ${basicButton.props};
  text-decoration: none;
  color: white;
  &:hover,
  &:link,
  &:active,
  &:visited {
    text-decoration: none;
    color: ${lightColor};
  }

  &:hover {
    ${basicButton.hoverEffects}
  }
`;

export const Title = styled.h2`
  padding-bottom: 3rem;
  line-height: 0;
  font-size: 2em;
  h1 {
    font-size: 1.5em;
  }
`;

export const InfoParagraph = styled.p`
  padding: 0 2rem 3rem 0;
  font-size: 1.5em;
  width: 50ch;

  @media (max-width: 500px) {
    width: 30ch;
  }
`;

export const MutedText = styled.div`
  padding: 3rem 0 5rem 0;
  color: rgba(255, 255, 255, 0.7);
`;
